import { createRouter, createWebHistory } from 'vue-router'
import { commonModules } from '../../modules/common/modules'
import { getLenaModules } from '../../modules/contrib/modules_lena'

import { useSettingsStore } from '@/stores/settingsStore'
import { useBreadcrumbsStore } from '@/stores/breadcrumbs.store'

const lenaModules = getLenaModules()

const defaultRoutes = [
  {
    name: 'registration',
    path: '/registration',
    component: () => import('./views/RegistrationPage.vue'),
    meta: { layout: 'GuestLayout' }
  },
  {
    name: 'login',
    path: '/login',
    component: () => import('./views/LoginPage.vue'),
    meta: { layout: 'GuestLayout' }
  },
  {
    name: 'passwordRecovery',
    path: '/password-recovery',
    component: () => import('./views/PasswordRecoveryPage.vue'),
    meta: { layout: 'GuestLayout' }
  }
]

const prepareRoutes = (modules) => {
  return modules.flatMap(module => module.routes.map(route => ({
    ...route,
    meta: {
      ...route.meta,
      layout: route.meta?.layout || 'MainLayout'
    }
  })))
}

const routes = [
  ...defaultRoutes,
  ...prepareRoutes(lenaModules),
  ...prepareRoutes(commonModules)
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

const guestPages = ['login', 'registration', 'passwordRecovery']

const clearBreadcrumbs = () => {
  const breadcrumbsStore = useBreadcrumbsStore()
  breadcrumbsStore?.clearBreadcrumbs?.()
}

router.beforeEach(async (to, from, next) => {
  const gornSettings = useSettingsStore()

  // Если настройки ещё не загружены, грузим
  if (gornSettings.isEmpty) {
    try {
      await gornSettings.loadSettings()
    } catch (error) {
      console.error(error)
    }
  }

  const resetSettings = to.query['_reset-settings'] === 'true'
  if (resetSettings) {
    gornSettings.resetSettings()
  } else if (gornSettings.isAuthorized && guestPages.includes(to.name)) {
    return next('/')
  }

  if (!gornSettings.isAuthorized && !guestPages.includes(to.name)) {
    const from = to.fullPath
    return next('/login?_from=' + encodeURIComponent(from))
  }

  if (from.path !== to.path) {
    clearBreadcrumbs()
  }

  next()
})

export default router
